import { useForm } from "react-hook-form";
import usePut from "../../usePut";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import useRead from "../../useRead";
import { useState } from "react";

const useAddEditSalaryComponent = ({ componentIdForEdit } = {}) => {
  const navigate = useNavigate();

  const { control, watch, handleSubmit, setValue } = useForm({
    defaultValues: {
      calculation_type: "FIXED",
      derived_from: [],
      value: 0,
      epf_type: "",
      pro_rata: false,
      consider_for_epf: false,
      consider_for_esi: false,
      show_in_payslip: false,
    },
  });

  const { handleAuth: addReq } = usePut({
    url: "salary-components/create",
    refreshUrl: ["dashboard/company_completion_status", "is_permission_for_product"],
    onSuccess: () => {
      toast.success("Component added successfully");
      if (sessionStorage.getItem("onboarding_flow") === "true") {
        sessionStorage.removeItem("onboarding_flow");
        // navigate("/onboarding");
      } else {
        navigate("/company-settings/salary-structure");
      }
    },
    onError: (err) => {
      toast.error("Error adding component: " + err.message);
    },
  });
  const isAdding = addReq.isLoading;

  const getDerivedFromArray = (arr) => {
    const derivedFromArray = arr.map((el) => {
      return {
        component_id: el.value,
        name: el.label,
      };
    });

    return derivedFromArray;
  };

  const addComponent = (data) => {
    addReq.mutate({
      ...data,
      component_type: "EARNING",
      derived_from: getDerivedFromArray(data.derived_from),
    });
  };

  const { handleAuth: editReq } = usePut({
    url: "salary-components/update",
    refreshUrl: ["dashboard/company_completion_status", "is_permission_for_product"],
    onSuccess: () => {
      toast.success("Component updated successfully");
    },
    onError: (err) => {
      toast.error("Error updating component: " + err.message);
    },
  });
  const isEditing = editReq.isLoading;

  const editComponent = (data) => {
    editReq.mutate({
      ...data,
      component_type: "EARNING",
      derived_from: getDerivedFromArray(data.derived_from),
    });
  };

  // For fetching derived options
  const [derivedOptions, setDerivedOptions] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  const { list, setGetListParams } = useRead({
    url: "salary-components/list",
    method: "GET",
    initialData: {
      pageNo: 0,
      limit: 10,
    },
    onSuccess: (data, reqParams) => {
      const filteredList = data.component_data.filter(
        (el) => el.component_id !== componentIdForEdit
      );

      const transformedList = filteredList.map((el) => {
        return {
          label: el.name,
          value: el.component_id,
        };
      });

      setDerivedOptions((prev) => {
        return [...prev, ...transformedList];
      });

      if (reqParams.pageNo === 0) setDerivedOptions(transformedList);

      setHasMore(data.pagination.has_more_pages);
    },
    onError: (err) => {
      toast.error("Error fetching derived options: " + err.message);
    },
  });

  const fetchNextDerivedOptions = (query, isNewSearch = false) => {
    if (isNewSearch) {
      setDerivedOptions([]);
      setHasMore(true);
      setGetListParams({
        pageNo: 0,
        search: query,
      });
    } else {
      setGetListParams((prev) => ({
        ...prev,
        pageNo: prev.pageNo + 1,
        search: prev.search || query,
      }));
    }
  };

  return {
    control,
    watch,
    handleSubmit,
    setValue,
    addComponent,
    isAdding,
    editComponent,
    isEditing,
    // Derived options
    derivedOptions,
    hasMore,
    fetchNextDerivedOptions,
  };
};

export default useAddEditSalaryComponent;
